export default __webpack_public_path__ + "static/media/CapaBackIcon.7944bb90.svg";